import React from "react";
import "./TestimonialsSection.scss";
import { Row, Col, Button, Carousel, Layout } from "antd";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
const { Content } = Layout;

const testimonialData = [
    {
        'img': '/ai_creator/img-butler.jpg',
        'quote': 'We’ve had the pleasure of working with ALL3D for over five years across several of their product services, and our latest experience with their AI imagery tool has further solidified why we continue to choose them over other vendors.',
        'name': 'Hanna O’Meara, VP Of Marketing',
        'company': 'Hooker Furniture',
        'logo': '/ai_creator/logo-butler.jpg'
    },
    // {
    //     'img': '/smb/car_2.png',
    //     'quote': 'Quote Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean convallis mollis velit quis imperdiet. Sed scelerisque odio in dictum lacinia. Vestibulum consectetur blandit ligula, quis efficitur erat pharetra et.',
    //     'name': 'Name',
    //     'company': 'Hooker Furniture',
    //     'logo': '/brands/Home-Depot.png'
    // },
    // {
    //     'img': '/Img.png',
    //     'quote': 'Quote Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean convallis mollis velit quis imperdiet. Sed scelerisque odio in dictum lacinia. Vestibulum consectetur blandit ligula, quis efficitur erat pharetra et.',
    //     'name': 'Name',
    //     'company': 'Hooker Furniture',
    //     'logo': '/brands/Hooker-Furnishings.png'
    // },
];

const TestimonialsSection = () => {

    return (
        <>
            <WebVersion />
            <MobileVersion />
        </>
    );
}

const WebVersion = () => {

    let carousel = React.createRef();


    const next = () => {
        if (carousel) {
            carousel.next();
        }
    };

    const prev = () => {
        if (carousel) {
            carousel.prev();
        }
    };


    return (
        <Content className="d-none d-lg-block">
            <Row className="container-fluid justify-in-center testimonials-bg">
                <Col span={24} className="justify-in-center text-center mb-56">
                    <h1 className="manrope f-38 lh-46 w-600 white">Hear it from our customers</h1>
                </Col>

                <Col span={2} className="direction-flex justify-in-start">
                    <Button onClick={prev}
                        icon={<ArrowLeftOutlined className="manrope f-20 lh-0" />}
                        className="carousel-btn-ar"
                    />
                </Col>

                <Col span={18}>
                    <div className="testimonial-carousel">
                        <Carousel
                            dots={true}
                            autoplay={false}
                            ref={(node) => carousel = node}
                            style={{ width: "100%" }}>
                            {testimonialData.map((data, index) => (
                                <Row className="testimonial-slide-bg" key={index}>
                                    <Col span={12} className="carousel-image-col">
                                        <img src={data.img} className="testimonial-img" alt="Customer testimonial" style={{maxWidth:'500px', maxHeight:'450px'}} />
                                    </Col>
                                    <Col span={12} className="carousel-text-col">
                                        <div>
                                            <p className="manrope f-20 w-500 black-085 lh-28 text-left left quote" style={{"marginRight":'30px'}}>"{data.quote}"</p>
                                            <p className="manrope f-14 lh-22 black-085 w-500 text-left left mb-16">– {data.name}, {data.company}</p>
                                            <img src={data.logo} alt={data.company} style={{maxWidth:'221px', maxHeight:'60px', objectFit:'contain',marginTop:'48px',marginLeft:'-20px'}} />
                                        </div>
                                    </Col>

                                </Row>
                            ))}
                        </Carousel>
                    </div>
                </Col>
                <Col span={2} className="direction-flex justify-in-end">
                    <Button onClick={next}
                        icon={<ArrowRightOutlined className="manrope f-20 lh-0" />}
                        className="carousel-btn-ar"
                    />
                </Col>
            </Row>
        </Content>
    );
}

const MobileVersion = () => {

    const settings = {
        autoplay: false,
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 1.07,
        slidesToScroll: 1,
        vertical: false,
        customPaging: i => (
            <div className="custom-dot">
                {/* &ndash;  This is the dash */}
            </div>
        ),
    };

    return (
        <Content className="d-lg-none">
            <Row className="container-fluid justify-in-center testimonials-bg">
                <Col span={24} className="justify-in-center text-center mb-32 pdlr-16">
                    <h1 className="manrope f-30 lh-46 w-600 white">Hear it from our customers</h1>
                </Col>

                <Col span={24} className="pdl-16">
                    <Slider {...settings} className="testimonials-card">
                        {testimonialData.map((data, index) => (
                            <Row className={`testimonial-slide-bg ${index === 0 ? `first` : ``}`} key={index}>
                                <div className="box">
                                    <div className="img-setting-col">
                                        <img src={data.img} className="testimonial-img mb-16" alt="Customer testimonial" />
                                    </div>
                                    <div className="pdlr-16">
                                        <p className="manrope f-16 w-500 black-085 lh-24 text-left mb-16">
                                            "{data.quote}"
                                        </p>
                                        <p className="manrope f-14 lh-22 black-085 w-500 text-left mb-16">– {data.name}, {data.company}</p>
                                        <img src={data.logo} className="mb-16" alt={data.company} style={{maxWidth:'180px', maxHeight:'40px', objectFit:'contain'}} />
                                    </div>
                                </div>
                            </Row>
                        ))}
                    </Slider>
                </Col>

            </Row>
        </Content>
    );
}


export default TestimonialsSection;
